import { HttpService } from 'core/modules/network-service';
import { get } from 'lodash';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getVisibleItems, isVisible } from 'resolvers/getVisibleEntities';

/*************************************************************/

/**
 * @type {class}
 * @desc MemberSavedAddress defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { MemberSavedAddressService } from 'services/memberSavedAddress';
 *
 * // create service instance and send/cancel request
 * const memberSavedAddressService = new MemberSavedAddressService();
 * const result = await memberSavedAddressService.fetchData( '<user-id>' ); // fetch data
 * memberSavedAddressService.cancel(); // cancel an active request
 */
export class MemberSavedAddressService extends HttpService {

    // make request and fetch data
    async fetchComponentData( { url, data } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            // extract data
            const visibility = get( response, 'body.component.visibility', {} );
            const modifyActions = get( response, 'body.component.structure.modifyActions', {} );
            const addAction = get( response, 'body.component.structure.addAction', {} );
            const component = get( response, 'body.component', {} );
            
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    options: get( response, 'body.component.data.options', {} ),
                    addresses: get( response, 'body.component.data.state.addresses', {} ),
                    addAction: isVisible( addAction, visibility ) ? addAction: {},
                    modifyActions: getVisibleItems( modifyActions, visibility ),
                    changeConfirmation: get( component, 'structure.widgetConfig.changeConfirmation', {} ),
                    ...get( response, 'body.component.structure.widgetConfig', {} ),
                    defaultDescription: isVisible( get( component, 'structure.widgetConfig.defaultDescription', {} ), visibility ) ? get( response, 'body.component.structure.widgetConfig.defaultDescription', {} ): {},
                },
            };
            
        } catch( errResponse ) {
            return this._errorFormatter( errResponse );
        }
    }

    // make request and fetch data
    async setDefaultAddress( { url, data } ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data
            } );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: get( response, 'body.component.data.state', get( response, 'body.component.data', {} ) ),
            };

        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
            };
        }
    }

    // make request and fetch data
    async deleteSavedAddress( { url, data } ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: get( response, 'body.component.data.state', get( response, 'body.component.data', {} ) ),
            };

        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
            };
        }
    }

    // make request and fetch data
    async inactivateSavedAddress( { url, data } ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: get( response, 'body.component.data.state', get( response, 'body.component.data', {} ) ),
            };

        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
            };
        }
    }

    // make request and fetch data
    async activateSavedAddress( { url, data } ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: get( response, 'body.component.data.state', get( response, 'body.component.data', {} ) ),
            };

        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
            };
        }
    }


    // get the valid address
    async submitSelectedAddress( { url, data } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: get( response, 'body.component.data.state', get( response, 'body.component.data', {} ) ),

                // data: {
                //     id: get( response, 'body.status.component.data.itemdIds', [] ),
                // }
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
